// extracted by mini-css-extract-plugin
export var cardContainer = "_qp-0";
export var cardHeader = "_qp-2";
export var collapsedState = "_qp-3";
export var dragHandle = "_qp-5";
export var dragHandleIcon = "_qp-6";
export var dragging = "_qp-1";
export var titleArea = "_qp-4";